<script setup lang="ts">
defineProps<{
  icon: string
}>()
</script>

<template>
  <button
    type="button"
    class="inline-flex items-center justify-center size-10 rounded-pill border border-white/30 bg-white/10 text-white backdrop-blur-sm opacity-50 transition-opacity hover:opacity-100 focus-visible:opacity-100"
  >
    <UIcon
      :name="icon"
      class="size-5"
    />
  </button>
</template>
